import { PageInputPopover } from "@/components/pagination/page-input-popover";
import {
  PaginationContent,
  PaginationFirst,
  PaginationItem,
  PaginationLast,
  PaginationNext,
  PaginationPrevious,
  Pagination as ShadPagination,
} from "@/components/ui/pagination";

export interface PaginationProps {
  currentPage: number;
  lastPage: number;
  canGoPrevious: boolean;
  canGoNext: boolean;
  onFirstPage: () => void;
  onPreviousPage: () => void;
  onNextPage: () => void;
  onLastPage: () => void;
  onGoToPage: (page: number) => void;
  isLoading?: boolean;
}

export function Pagination({
  currentPage,
  lastPage,
  canGoPrevious,
  canGoNext,
  onFirstPage,
  onPreviousPage,
  onNextPage,
  onLastPage,
  onGoToPage,
  isLoading,
}: PaginationProps) {
  return (
    <div className="border-border xs:flex-0 flex h-9 flex-1 items-center rounded-lg border p-1">
      <ShadPagination>
        <PaginationContent className="gap-0.5">
          <PaginationItem className="hidden lg:block">
            <PaginationFirst
              onClick={onFirstPage}
              disabled={!canGoPrevious}
              className="hover:bg-muted/60 h-7 w-7 rounded-md border-0 p-0 transition-colors"
            />
          </PaginationItem>
          <PaginationItem>
            <PaginationPrevious
              onClick={onPreviousPage}
              disabled={!canGoPrevious}
              className="hover:bg-muted/60 h-7 w-7 rounded-md border-0 p-0 transition-colors"
            />
          </PaginationItem>
          <PaginationItem>
            <PageInputPopover
              currentPage={currentPage}
              lastPage={lastPage}
              onGoToPage={onGoToPage}
              isLoading={isLoading}
            />
          </PaginationItem>
          <PaginationItem>
            <PaginationNext
              onClick={onNextPage}
              disabled={!canGoNext}
              className="hover:bg-muted/60 h-7 w-7 rounded-md border-0 p-0 transition-colors"
            />
          </PaginationItem>
          <PaginationItem className="hidden lg:block">
            <PaginationLast
              onClick={onLastPage}
              disabled={!canGoNext}
              className="hover:bg-muted/60 h-7 w-7 rounded-md border-0 p-0 transition-colors"
            />
          </PaginationItem>
        </PaginationContent>
      </ShadPagination>
    </div>
  );
}
